import { batchActions } from './utils';
import { setData } from './data';
import { setStatus, unsetStatus } from './status';
import { LOADING, ERROR, selectEpisodeListenersStatus, selectDateRange } from './selectors';
import { toJSON, PODCASTERS_SERVICE } from '../lib/Request';
import { Thunk, DateRangeWithLabel } from '../types';

type CountWithDate = {
  count: number;
  date: string;
};

type ListenersResponse = {
  counts: CountWithDate[];
};

export const loadEpisodeListeners = (episodeId: string): Thunk => async (
  dispatch,
  getState,
  { request },
) => {
  const key = 'episodeListeners';

  const { startDate, endDate } = selectDateRange(getState()) as DateRangeWithLabel;
  const endpoint = `${PODCASTERS_SERVICE}/v0/episodes/${episodeId}/listeners?start=${startDate}&end=${endDate}`;

  /* istanbul ignore next */
  if (selectEpisodeListenersStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [key]: LOADING }, 'audience/LOAD_EPISODE_LISTENERS_REQUEST'));

  try {
    const { counts: data }: ListenersResponse = await request.get(endpoint).then(toJSON);

    dispatch(
      batchActions(
        [setData({ [key]: data }), unsetStatus([key])],
        'audience/LOAD_EPISODE_LISTENERS_SUCCESS',
      ),
    );
  } catch (err) {
    switch (err.name) {
      case 'ResponseError':
      case 'TokenError': {
        dispatch(setStatus({ [key]: ERROR }, 'audience/LOAD_EPISODE_LISTENERS_ERROR'));
        break;
      }

      /* istanbul ignore next */
      default:
        throw err;
    }
  }
};
